/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Ground_Item_BillingInputs */

const en_auth_ground_item_billing = /** @type {(inputs: Auth_Ground_Item_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposals and invoices`)
};

/** @type {(inputs: Auth_Ground_Item_BillingInputs) => LocalizedString} */
const ar_auth_ground_item_billing = en_auth_ground_item_billing;

/** @type {(inputs: Auth_Ground_Item_BillingInputs) => LocalizedString} */
const he_auth_ground_item_billing = en_auth_ground_item_billing;

/** @type {(inputs: Auth_Ground_Item_BillingInputs) => LocalizedString} */
const ur_auth_ground_item_billing = en_auth_ground_item_billing;

/** @type {(inputs: Auth_Ground_Item_BillingInputs) => LocalizedString} */
const es_auth_ground_item_billing = en_auth_ground_item_billing;

/** @type {(inputs: Auth_Ground_Item_BillingInputs) => LocalizedString} */
const fr_auth_ground_item_billing = en_auth_ground_item_billing;

/** @type {(inputs: Auth_Ground_Item_BillingInputs) => LocalizedString} */
const de_auth_ground_item_billing = en_auth_ground_item_billing;

/** @type {(inputs: Auth_Ground_Item_BillingInputs) => LocalizedString} */
const pt_auth_ground_item_billing = en_auth_ground_item_billing;

/** @type {(inputs: Auth_Ground_Item_BillingInputs) => LocalizedString} */
const hi_auth_ground_item_billing = en_auth_ground_item_billing;

/** @type {(inputs: Auth_Ground_Item_BillingInputs) => LocalizedString} */
const bn_auth_ground_item_billing = en_auth_ground_item_billing;

/**
* | output |
* | --- |
* | "Proposals and invoices" |
*
* @param {Auth_Ground_Item_BillingInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const auth_ground_item_billing = /** @type {((inputs?: Auth_Ground_Item_BillingInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Ground_Item_BillingInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_auth_ground_item_billing(inputs)
	if (locale === "he") return he_auth_ground_item_billing(inputs)
	if (locale === "ur") return ur_auth_ground_item_billing(inputs)
	if (locale === "es") return es_auth_ground_item_billing(inputs)
	if (locale === "fr") return fr_auth_ground_item_billing(inputs)
	if (locale === "de") return de_auth_ground_item_billing(inputs)
	if (locale === "pt") return pt_auth_ground_item_billing(inputs)
	if (locale === "hi") return hi_auth_ground_item_billing(inputs)
	if (locale === "bn") return bn_auth_ground_item_billing(inputs)
	return /** @type {LocalizedString} */ ("Proposals and invoices")
});